<div class="container">
	<div class="d-flex justify-content-center h-100">
		<div class="card">
            <div class="card-header">
				<h3>Sign In</h3>
			</div>
			<div class="card-body">
				<form>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></span>
						</div>
						<input type="text" class="form-control" placeholder="Username" #userName required>
						
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></span>
						</div>
						<input type="password" class="form-control" placeholder="Password" #userPassword required>
					</div>
					<div class="form-group">
						<input type="submit" value="Login" class="btn btn-block login_btn" (click)="authService.signIn(userName.value, userPassword.value)">
					</div>
				</form>
			</div>
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					Don't have an account?<a routerLink="/register-user">Sign Up</a>
				</div>
				<div class="d-flex justify-content-center">
					<a routerLink="/forgot-password">Forgot your password?</a>
				</div>
			</div>
		</div>
	</div>
</div>
